import { type ForceAddMentionsMentionData } from "shared/services/api/StreamService";
import { type MentionType } from "shared/types/mentions";

import {
  type CannotBeAddedReason,
  type UrlStatus as UrlApiStatus,
} from "../useAddExternalItemsWorkflow/useUrlVerificationNotificationsSubscription";

export type ExistingMentionData = ForceAddMentionsMentionData;

export interface UrlData {
  addedInCurrentFlow?: boolean;
  mentionId?: number;
  mentionType?: MentionType;
  reason?: CannotBeAddedReason;
  status: UrlDataStatus;
  url: string;
}

type MandatoryUrlData = Pick<UrlData, "url" | "status">;
export type AlreadyAddedUrlData = MandatoryUrlData &
  Pick<UrlData, "mentionId" | "addedInCurrentFlow"> &
  Required<Pick<UrlData, "mentionType">>;

export enum UrlLocalStatus {
  pending = "pending",
}

export type UrlDataStatus = UrlApiStatus | UrlLocalStatus;

export interface UrlValueChange {
  newValue: string;
  oldValue: string;
}
